// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"styles_footerWrapper__Zm_ZS","footerContent":"styles_footerContent__YwdTT","subtext":"styles_subtext__OJhb_"};